import { cm } from 'src/utils/classNames';
import { BigNum } from '@drift-labs/sdk';
import SkeletonValuePlaceholder from '../SkeletonValuePlaceholder/SkeletonValuePlaceholder';
import { WithChildren, WithClassName } from 'src/utils/UtilityTypes';

interface QuickActionButtonProps extends WithClassName, WithChildren {
	onClick: () => void;
}

const QuickActionButton = (props: QuickActionButtonProps) => {
	return (
		<button
			type="button"
			className={cm(
				'flex items-center gap-x-xs rounded-xs px-xs py-2xs',
				'bg-button-secondary-bg-hover typo-b5 text-text-default',
				props.className
			)}
			onClick={props.onClick}
		>
			{props.children}
		</button>
	);
};

const FiftyPercentButton = (props: { onClick: () => void }) => (
	<QuickActionButton onClick={props.onClick}>50%</QuickActionButton>
);

const MaxButton = (props: {
	onClick: () => void;
	maxAmount: BigNum;
	isLoading?: boolean;
}) => (
	<QuickActionButton onClick={props.onClick}>
		<span>Max:</span>
		{props.isLoading ? (
			<SkeletonValuePlaceholder className="h-3 w-10" loading />
		) : (
			props.maxAmount.toMillified()
		)}
	</QuickActionButton>
);

const CustomLabelButton = (props: {
	onClick: () => void;
	label: string;
	amount?: BigNum;
	isLoading?: boolean;
}) => (
	<QuickActionButton onClick={props.onClick}>
		<span>{props.label}</span>
		{props.amount !== undefined &&
			(props.isLoading ? (
				<SkeletonValuePlaceholder className="h-3 w-12" loading />
			) : (
				props.amount.toMillified()
			))}
	</QuickActionButton>
);

const SizePresets = (props: {
	onClick: (amount: BigNum) => void;
	maxAmount: BigNum;
	isLoading?: boolean;
}) => {
	return (
		<div className="flex items-center gap-1">
			<FiftyPercentButton
				onClick={() => props.onClick(props.maxAmount.div(BigNum.from(2)))}
			/>
			<MaxButton
				onClick={() => props.onClick(props.maxAmount)}
				maxAmount={props.maxAmount}
				isLoading={props.isLoading}
			/>
		</div>
	);
};

export const InputQuickActions = {
	FiftyPercentButton,
	MaxButton,
	CustomButton: CustomLabelButton,
	SizePresets,
};
